import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import { requestAddins } from "./actions"

import AddIns from "./components/Addins"
import { IOldUIContext, IOldUIInit } from "../../global"

function init(store: AppStore, oldUIContext: IOldUIContext): IOldUIInit {
    const start = (): void => {
        const element = document.getElementById("newui-addins")
        if (element) {
            const root = createRoot(element)
            store.dispatch(requestAddins())

            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <OldUIContext.Consumer>
                            {(): JSX.Element => <AddIns />}
                        </OldUIContext.Consumer>
                    </OldUIContext.Provider>
                </Provider>,
            )
        }
    }

    return {
        start,
    }
}

export default init
